/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Timing_Settings_UpdatedInputs */

const en_project_timing_settings_updated = /** @type {(inputs: Project_Timing_Settings_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project timing settings updated.`)
};

const fr_project_timing_settings_updated = /** @type {(inputs: Project_Timing_Settings_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres de minutage du projet mis à jour.`)
};

const de_project_timing_settings_updated = /** @type {(inputs: Project_Timing_Settings_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Projektzeiteinstellungen wurden aktualisiert.`)
};

const it_project_timing_settings_updated = /** @type {(inputs: Project_Timing_Settings_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni di temporizzazione del progetto aggiornate.`)
};

const ru_project_timing_settings_updated = /** @type {(inputs: Project_Timing_Settings_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновлены настройки сроков выполнения проекта.`)
};

const es_project_timing_settings_updated = /** @type {(inputs: Project_Timing_Settings_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se actualizaron las configuraciones de tiempo del proyecto.`)
};

const zh_cn2_project_timing_settings_updated = /** @type {(inputs: Project_Timing_Settings_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目时间设置已更新。`)
};

const ja_project_timing_settings_updated = /** @type {(inputs: Project_Timing_Settings_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトのタイミング設定が更新されました。`)
};

const hi_project_timing_settings_updated = /** @type {(inputs: Project_Timing_Settings_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट के समय निर्धारण संबंधी सेटिंग्स अपडेट कर दी गई हैं।`)
};

const pt_pt2_project_timing_settings_updated = /** @type {(inputs: Project_Timing_Settings_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de tempo do projeto atualizadas.`)
};

/**
* | output |
* | --- |
* | "Project timing settings updated." |
*
* @param {Project_Timing_Settings_UpdatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_timing_settings_updated = /** @type {((inputs?: Project_Timing_Settings_UpdatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Timing_Settings_UpdatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_timing_settings_updated(inputs)
	if (locale === "de") return de_project_timing_settings_updated(inputs)
	if (locale === "it") return it_project_timing_settings_updated(inputs)
	if (locale === "ru") return ru_project_timing_settings_updated(inputs)
	if (locale === "es") return es_project_timing_settings_updated(inputs)
	if (locale === "zh-CN") return zh_cn2_project_timing_settings_updated(inputs)
	if (locale === "ja") return ja_project_timing_settings_updated(inputs)
	if (locale === "hi") return hi_project_timing_settings_updated(inputs)
	if (locale === "pt-PT") return pt_pt2_project_timing_settings_updated(inputs)
	return en_project_timing_settings_updated(inputs)
});